// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/shapes/waves-white.svg";
import techVescosityLogo from "assets/images/logos/techVescosityLogo.png";

function Download() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 6 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 12 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white">
              Do you love this awesome
            </MKTypography>
            <MKTypography variant="h3" color="white" mb={1}>
              Virtual &amp; Staging?
            </MKTypography>
            <MKTypography variant="body2" color="white" mb={6}>
              Enjoyed the AI magic? Sign in to access your staged rooms, explore more styles, and
              bring your vision to life with just a click!
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              size="large"
              component="a"
              href="/sign-in"
              sx={{ mb: 2 }}
            >
              Sign in Today
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Container>
        <Grid container item xs={6} mx="auto">
          <MKBox textAlign="center">
            <MKTypography variant="h3" mt={6} mb={3}>
              Product By:
            </MKTypography>
            <Grid container spacing={0} justifyContent="center">
              <Grid item xs={6} lg={6}>
                <Tooltip title="Tech Vescosity">
                  <MKBox component="a" href="https://vescosity.com" target="_blank">
                    <MKBox component="img" src={techVescosityLogo} width="100%" />
                  </MKBox>
                </Tooltip>
              </Grid>
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Download;
